import { Flex, PageContent, PageHeader, Space } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { NavigateReportPageButton } from '@/features/project/_components/NavigateReportPageButton';
import { useTranslation } from 'react-i18next';
import { NavigateCreatePageButton } from '../../_components/NavigateCreatePageButton';
import { SegmentSwitcher } from '../../_components/SegmentSwitcher';
import { GroupCreateModalButton } from '../_components/GroupCreateModalButton';
import { ProjectGroupList } from '../_components/ProjectGroupList';

export const GroupsPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t('projects-page')}
        breadcrumbs={[{ title: t('projects-page') }]}
        buttons={
          <Space>
            <NavigateReportPageButton />
            <ProjectResourceGuard onlyEdit>
              <Space>
                <GroupCreateModalButton />
                <NavigateCreatePageButton text={t('create-project')} />
              </Space>
            </ProjectResourceGuard>
          </Space>
        }
      />
      <PageContent>
        <Flex vertical gap={16}>
          <SegmentSwitcher segment="group" />
          <ProjectGroupList />
        </Flex>
      </PageContent>
    </>
  );
};
